'use strict'

import Vue from 'vue'
import axios from 'axios'

// axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers.tenant_id = 1

let config = {
  //  baseURL:'/api/',
  // baseURL:'http://192.168.10.8:11111/gunsApi'
  // baseURL: "http://49.232.170.124:9999"

  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}
// console.log(vue.$store.state.s)
const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前执行某些操作
    if (config.method === 'post') {
      config.data = JSON.stringify(config.data)
    }

    // let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MDk4MTAxNDcsInVzZXJuYW1lIjoiYWRtaW4ifQ.Vvli8jlT3s9faV8UHFFsbLW20PXUmXRyCC4f_En1x_E'
    let token = sessionStorage.getItem('token')
    if (token) {
      // config.headers.Authorization = 'Bearer ' + token
      config.headers['X-Access-Token'] =  token
    }
    // 请求头携带的信息
    return config
  },
  function (error) {
    // 处理请求错误
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    if (!response) {
      // 处理响应错误
      return Promise.reject(response)
    } else {
      // 对响应数据做些什么
      return response
    }
  },
  function (error) {
    // 处理响应错误
    return Promise.reject(error)
  }
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      }
    },
    $axios: {
      get () {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default { Plugin, config }



// WEBPACK FOOTER //
// ./src/plugins/axios.js